import { Injectable } from '@angular/core';
import { ResourceService } from '../../shared/resource.service';
import { CustomerReference } from './customer-reference';
import { CustomerReferenceSerializer } from './customer-reference.serializer';
import { Http } from '@angular/http';
import { environment } from '../../../environments/environment';

@Injectable()
export class CustomerReferenceService extends ResourceService<CustomerReference> {
  baseUrl = environment.serverUrl + 'reference/customers/';
  allSelected = false;

  constructor(http: Http) {
    super(http, 'reference/customers/', new CustomerReferenceSerializer());
  }
}
